import { PathBase } from "@constellation-academy/epic-ui";

export class InstructorEditPath extends PathBase {
	static readonly pathKey = "edit";
}
